import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=062b8d77&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"
import style0 from "./Quote.vue?vue&type=style&index=0&id=062b8d77&prod&scoped=true&lang=css"
import style1 from "./Quote.vue?vue&type=style&index=1&id=062b8d77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b8d77",
  null
  
)

export default component.exports